import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileUploadTake from '../Take';
var defaultUserResponse = {
  value: []
};
var noop = function noop() {};

/**
---
category: FileUpload
---

  File Upload Show component

  ```jsx_example
  <SettingsSwitcher locales={LOCALES}>
    <FileUploadShow
      itemBody="Give three examples of people"
      interactionData={{
        restrictCount: true,
        filesCount: 3
      }}
      properties={{
        restrictTypes: false,
        allowedTypes: ''
      }}
    />
  </SettingsSwitcher>
  ```
**/
var FileUploadShow = /*#__PURE__*/function (_Component) {
  function FileUploadShow() {
    _classCallCheck(this, FileUploadShow);
    return _callSuper(this, FileUploadShow, arguments);
  }
  _inherits(FileUploadShow, _Component);
  return _createClass(FileUploadShow, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FileUploadTake, Object.assign({}, this.props, {
        handleResponseUpdate: noop,
        mediaUpload: noop,
        cancelMediaUpload: noop,
        userResponse: defaultUserResponse,
        readOnly: true
      }));
    }
  }]);
}(Component);
_defineProperty(FileUploadShow, "propTypes", {
  itemBody: PropTypes.string.isRequired,
  interactionData: PropTypes.shape({
    restrictCount: PropTypes.bool.isRequired,
    filesCount: PropTypes.string.isRequired
  }).isRequired,
  properties: PropTypes.shape({
    restrictTypes: PropTypes.bool.isRequired,
    allowedTypes: PropTypes.string
  }).isRequired
});
export { FileUploadShow as default };